import React from "react";
import { CurrencyRupeeIcon } from "@heroicons/react/outline";

const MetalPolicyCard = ({ metal, policy, onPolicyChange }) => {
  const getColorClasses = () => {
    const colorMap = {
      gold: 'border-yellow-200 bg-yellow-50 text-yellow-800',
      silver: 'border-gray-200 bg-gray-50 text-gray-800',
      platinum: 'border-purple-200 bg-purple-50 text-purple-800',
      diamond: 'border-blue-200 bg-blue-50 text-blue-800',
    };
    return colorMap[metal.id] || 'border-gray-200 bg-gray-50';
  };

  const getIconColor = () => {
    const iconMap = {
      gold: 'text-yellow-600',
      silver: 'text-gray-500',
      platinum: 'text-purple-600',
      diamond: 'text-blue-600',
    };
    return iconMap[metal.id] || 'text-gray-500';
  };

  return (
    <div className={`border rounded-lg p-4 ${getColorClasses()}`}>
      <h4 className="font-medium flex items-center mb-3">
        <CurrencyRupeeIcon className={`h-5 w-5 mr-2 ${getIconColor()}`} />
        {metal.name} Policy
      </h4>
      <div className="space-y-3">
        <label className="flex items-center">
          <input
            type="radio"
            name={`${metal.id}Policy`}
            checked={policy === "INHERIT"}
            onChange={() => onPolicyChange("INHERIT")}
            className={`h-4 w-4 mr-3 text-${metal.color}-600`}
          />
          <span>Inherit from main branch</span>
        </label>
        <label className="flex items-center">
          <input
            type="radio"
            name={`${metal.id}Policy`}
            checked={policy === "CUSTOM"}
            onChange={() => onPolicyChange("CUSTOM")}
            className={`h-4 w-4 mr-3 text-${metal.color}-600`}
          />
          <span>Use custom rates</span>
        </label>
      </div>
    </div>
  );
};

export default MetalPolicyCard;
